import styled from 'styled-components';

export const BaseCard = styled.div`
	/* Fixed dimensions - ALL cards must use these exact values */
	width: 700px;
	height: 600px;
	min-width: 700px;
	min-height: 400px;
	max-width: 600px;
	max-height: 600px;

	/* Fixed styling */
	padding: 40px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
	border-radius: 20px;
	background: #fff;

	/* Carousel behavior */
	flex-shrink: 0;
	scroll-snap-align: center;

	/* Layout */
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	overflow: hidden;
	box-sizing: border-box;

	/* Entrance animation */
	animation: slideInFromRight 0.6s cubic-bezier(0.4, 0, 0.2, 1);

	@keyframes slideInFromRight {
		from {
			opacity: 0;
			transform: translateX(50px) scale(0.95);
		}
		to {
			opacity: 1;
			transform: translateX(0) scale(1);
		}
	}
`;
